import kebabCase from 'lodash/kebabCase';

export const obterPrimeiraPalavra = (nome: string | null | undefined) => {
  if (!nome) return '';
  return nome.split(' ')[0];
};

export const converterParaKebabCase = (nome?: string | null) => {
  return kebabCase(nome?.toLowerCase());
};
